/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import imageCompression from 'browser-image-compression';
import React, {useEffect, useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import {toDate} from '../../../common/utils/date';
import {defaultValues} from '../../../data/constants/inscription';
import {IError} from '../../../data/types/interface/inscription';
import {StackParams} from '../../../data/types/navigation';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import {postFormData} from '../../../services/technique/api';
import {HeaderScreen} from '../../components/Header/HeaderScreen';
import {Loader} from '../../components/Loader';
import ConfirmationModal from '../../components/Modal/ConfirmationModal';
import {PageContainer} from '../../components/PageContainer';
import {Form} from './FormWeb';

type NavigationProps = StackNavigationProp<StackParams, 'Inscription'>;

const dataWs = {
  ...defaultValues,
};

export const FInscription = (props: any) => {
  const {navigate, goBack} = useNavigation<NavigationProps>();
  const [listAgence, setListAgence] = useState([]);
  const [dataDto, setDataDto] = useState(dataWs);
  const [postSucces, setPostSuccess] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const {inscriptionUser, route} = props;
  const {
    data,
    typeAssurance,
    age,
    montant,
    isSimulation,
    typeId = '',
  } = route && route.params ? route.params : '';

  const [messageErreur, setMessageErreur] = useState('');
  const [showModal, setShowModal] = useState(false);

  const handleCancel = () => {
    goBack();
  };

  const handleConnection = () => {
    navigate('Login');
  };

  const formDataDTO = async (InscriptionDTO: IError) => {
    const formData = new FormData();
    for (const cin of InscriptionDTO.cin) {
      const compressed = await imageCompression(cin, {});
      formData.append('cin', compressed, cin.name);
    }
    formData.append('nom', InscriptionDTO.nom);
    formData.append('prenom', InscriptionDTO.prenom);
    formData.append('telephone', InscriptionDTO.telephone);
    formData.append('countryCode', InscriptionDTO.countryCode || 'MG');
    formData.append('email', InscriptionDTO.email);
    formData.append('ville', InscriptionDTO.ville);
    formData.append('adresse', InscriptionDTO.adresse);
    formData.append('password', InscriptionDTO.password);
    formData.append('dateNaissance', InscriptionDTO.dateNaissance);
    const compressed = await imageCompression(InscriptionDTO.image[0], {});
    formData.append('image', compressed, InscriptionDTO.image[0].name);

    return formData;
  };

  const checkResponse = (response: any) => {
    if (response && !response.isError && response.data) {
      inscriptionUser({...response}, () => {
        if (isSimulation) {
          if (data === 'SouscriptionAssuranceRCVPForm') {
            navigate('SouscriptionAssuranceRCVPForm', {
              typeAssurance: typeAssurance,
              montant: montant,
              typeId,
            });
          } else if (data === 'SouscriptionAssuranceScolaireForm') {
            navigate('SouscriptionAssuranceScolaireForm', {
              typeAssurance: typeAssurance,
              montant: montant,
              age: age,
              typeId,
            });
          } else {
            data === undefined ? navigate('Home') : navigate(data);
          }
        } else {
          if (data === 'SouscriptionAssuranceRetraiteForm') {
            navigate('SouscriptionAssuranceRetraiteForm', {
              premierVersement: '',
            });
          } else if (data === 'SouscriptionAssuranceScolaireForm') {
            navigate('SouscriptionAssuranceScolaireForm', {
              montant: '',
              typeId,
            });
          } else {
            data === undefined ? navigate('Home') : navigate(data);
          }
        }
      });
    } else {
      if (
        typeof response == 'string' &&
        response.includes('413 Request Entity Too Large')
      ) {
        setMessageErreur('Veuillez diminuer la taille de vos photos.');
        setShowModal(true);
      } else {
        setMessageErreur(response.message);
        setShowModal(true);
      }
    }
  };

  const proccessSave = (dataWs: any) => {
    formDataDTO(dataWs).then(res => {
      setIsLoading(true);
      postFormData('auth/inscription', res, '').then((response: any) => {
        setIsLoading(false);
        checkResponse(response);
      });
    });
  };

  const handleSubmit = (dataWs: any) => {
    const _data = {...dataWs};
    _data.dateNaissance = toDate(dataWs.dateNaissance);
    setDataDto(_data);
    proccessSave(dataWs);
  };

  useEffect(() => {}, [dataDto]);

  return (
    <View>
      <HeaderScreen title="Inscription" type="Unlogged" noBreadcrumb={false} />
      <PageContainer>
        {/** Confirmation modal */}
        {showModal && (
          <ConfirmationModal
            title="Erreur"
            content={messageErreur}
            btn1="OK"
            handleBtn1={() => {
              setShowModal(false);
            }}
          />
        )}

        {/** Loading */}
        {IsLoading && <Loader />}
        {/** Form content */}
        {!postSucces && !IsLoading && !showModal && (
          <Form
            data={dataDto}
            connectAction={handleConnection}
            listAgence={listAgence}
            onCancelForm={handleCancel}
            onSubmitForm={handleSubmit}
          />
        )}
      </PageContainer>
    </View>
  );
};
export const Inscription: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FInscription);
